export const NOTIFICATIONS_COPY = {
  pageTitle: "Notifications",
  markAll: "Mark all as read",
  loadMore: "Load more",
  retry: "Try again",
  refresh: "Refresh",
  unread: (label) => `${label} unread`,
};

export const NOTIFICATIONS_EMPTY = {
  heading: "No Notifications",
  body: "When you get notifications, they'll show up here",
};

export const NOTIFICATIONS_ERROR = {
  502: {
    heading: "Server Unavailable",
    body: "The server is temporarily unavailable. Please try again.",
  },
  403: {
    heading: "Access Denied",
    body: "You don't have permission to view these notifications.",
  },
  network: {
    heading: "Connection Problem",
    body: "We couldn't load your notifications. Check your connection and try again.",
  },
};
